import { ANALYTICS_URI, DASHBOARD_URI, INSIGHTS_URI, } from '@cores/constants/envConfig';
import { E_SPACE_TEXT_LANGUAGE } from './enums';
import { ViewType } from '@/domains/base/enums/view-type';
import { DataType } from '@/domains/base/enums/data-type';
// 文件夹列表侧边栏尺寸配置(单位: %)
/** 默认尺寸 */
export const FOLDER_LIST_ASIDE_DEFAULT_SIZE = 20;
/** 最小尺寸 */
export const FOLDER_LIST_ASIDE_MINI_SIZE = 20;
/** 最大尺寸 */
export const FOLDER_LIST_ASIDE_MAX_SIZE = 40;
export const DEFAULT_SPACE_SETTING = {
    stem: false,
    language: E_SPACE_TEXT_LANGUAGE.DEFAULT,
};
export const ANALYSIS_PRODUCT_LINK_TEMPLATE = {
    insights_analysis: `${INSIGHTS_URI}/#/CreateTechnologyReport?workspace_id=\${spaceId}&folder_id=\${folderId}&qid=\${q}&efqid=\${efq}&cond=\${cond}`,
    landscape_analysis: `${ANALYTICS_URI}/landscape?workspace_id=\${spaceId}&folder_id=\${folderId}&qid=\${q}&efqid=\${efq}&cond=\${cond}&sort=\${sort}&_type=workspace`,
    matrix_analysis: `${DASHBOARD_URI}/bi-tools/?workspace_id=\${spaceId}&folder_id=\${folderId}&qid=\${q}&efqid=\${efq}&cond=\${cond}&sourceFrom=workspace#/create`,
};
export const SUPPORTED_DATA_TYPES = [
    DataType.PATENT,
    DataType.PAPER,
    DataType.BIO,
    DataType.DRUG,
    DataType.CLINICAL,
    DataType.MARKET,
    DataType.MERGER,
    DataType.INVESTMENT,
    DataType.CLINICAL_RESULT,
];
export const PATENT_VIEW_TYPES = [
    ViewType.TABLE,
    ViewType.STANDARD,
    ViewType.FULL_IMAGE,
    ViewType.THUMB,
    ViewType.FAST_TABLE,
    ViewType.WORD_CLOUD,
    ViewType.CATEGORY,
];
export const DATA_TYPE_SUPPORTED_VIEW_TYPES_MAP = {
    [DataType.PATENT]: PATENT_VIEW_TYPES,
    [DataType.PAPER]: [ViewType.TABLE],
    [DataType.BIO]: [ViewType.TABLE],
    [DataType.DRUG]: [ViewType.TABLE],
    [DataType.CLINICAL]: [ViewType.TABLE],
    [DataType.MARKET]: [ViewType.TABLE],
    [DataType.MERGER]: [ViewType.TABLE],
    [DataType.INVESTMENT]: [ViewType.TABLE],
};
export const LAB_VIEW_TYPES = [ViewType.WORD_CLOUD, ViewType.FAST_TABLE];
